import { Template } from 'entities/template';
import { Client, Options } from 'services/apiGatewayClient';
import { createService } from 'services/genericAPIGatewayService';
import { State } from 'store';
import { Service } from './services';

interface TemplateListResponse {
  templates: Template[];
}

const options: Options<Template, Template, Template, TemplateListResponse> = {
  mapToRequest: (req: Template) => req,
  mapFromResponse: (resp: Template) => ({ id: resp.id, entity: resp }),
  mapFromListResponse: (resp: TemplateListResponse) => resp.templates.map(item => ({ id: item.id, entity: item })),
};

const client = new Client(options);

export const { Actions, Selectors, Sagas } = createService<Template, Service.Templates>({
  service: Service.Templates,
  client,
  // eslint-disable-next-line
  endpointCreator: '/sites/${siteId}/templates',
  stateConverter: (state: State) => state.assets.templates,
  sagas: ['GET_COLLECTION'],
});
